// ── priceCodes.js — 단가표 품목 코드 자동 번호 (V113) ─────────────────────────
//
// 코드는 영수증 매입가를 단가표 품목에 묶는 열쇠다. 영수증 OCR이 품목을 찾으면
// 그 행의 code를 priceCode로 저장하고, "내 평균가(30일)"가 이 코드로 묶어 계산한다.
// → 코드가 비어 있으면 그 품목은 영수증을 아무리 찍어도 평균가가 쌓이지 않는다.
//
// 규칙: 비어 있는 품목에만 P + 세 자리 순번(P001, P002 …)을 매긴다.
//       이미 있는 코드는 절대 바꾸지 않는다. 다음 번호 = 지금 있는 P번호 중 최대 + 1.
//       (S로 시작하는 반제품 코드, 사람이 직접 적은 다른 형식 코드는 그대로 두고 피해 간다)

const P_CODE = /^P(\d+)$/i;

/**
 * 목록을 보고 "다음 빈 번호"를 하나씩 내주는 함수를 만든다.
 * @param {Array} list 단가표 전체 (숨겨진 행 포함해서 넘길 것 — 번호 충돌 방지)
 * @returns {() => string}
 */
export function makeCodeAllocator(list) {
  let max = 0;
  const used = new Set();
  for (const p of list || []) {
    const c = String(p?.code || '').trim();
    if (!c) continue;
    used.add(c.toUpperCase());
    const m = P_CODE.exec(c);
    if (m) max = Math.max(max, parseInt(m[1], 10));
  }
  return () => {
    let code;
    do {
      max += 1;
      code = 'P' + String(max).padStart(3, '0');
    } while (used.has(code.toUpperCase()));
    used.add(code.toUpperCase());
    return code;
  };
}

/**
 * 코드가 빈 품목에만 번호를 매긴다. 다른 칸은 손대지 않는다.
 * @returns {{ next: Array, assigned: number }}
 */
export function assignMissingCodes(list) {
  const alloc = makeCodeAllocator(list);
  let assigned = 0;
  const next = (list || []).map(p => {
    if (!p || String(p.code || '').trim()) return p;
    assigned++;
    return { ...p, code: alloc() };
  });
  return { next, assigned };
}
